import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { StaticDatePicker } from '@mui/x-date-pickers/StaticDatePicker';
import { pl } from 'date-fns/locale'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { ThemeProvider, createTheme } from '@mui/material/styles'
import { plPL } from '@mui/x-date-pickers/locales'
import './BMXStaticDatePicker.scss'
import { useState } from 'react';
import PropTypes from 'prop-types';

const BMXStaticDatePicker = (props) => {
    const { className, onChange: _onChange, value: _value, handleHide, ...rest } = props;

    const [value, setValue] = useState(_value || new Date());

    const onChange = (newValue) => {
        setValue(newValue);
        _onChange(newValue);
    }

    const theme = createTheme({
        components: {
            MuiPickersToolbar: {
                styleOverrides: {
                    root: {
                        color: '#bbdefb',
                        borderRadius: '0px',
                        borderWidth: '0px',
                        borderColor: '#2196f3',
                        border: '0px solid',
                        backgroundColor: '#0d47a1',
                    }
                }
            }
        }
    }, plPL)

    return (
        <div className={`BMXStaticDatePicker ${className || ""}`}>
            <ThemeProvider theme={theme}>
                <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={pl} >
                    <StaticDatePicker value={value} onChange={(val) => {
                        onChange(val);
                        handleHide();
                    }} {...rest} views={['day']} />
                </LocalizationProvider>
            </ThemeProvider>
        </div>
    );
}

BMXStaticDatePicker.propTypes = {
    onChange: PropTypes.func.isRequired,
    value: PropTypes.instanceOf(Date).isRequired,
}

BMXStaticDatePicker.defaultProps = {
    onChange: (val) => console.log("change:", val),
    value: new Date(),
}

export default BMXStaticDatePicker;